import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipVerticalCircle20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFlipVerticalCircle20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M12.251 15.019a5.5 5.5 0 0 0 0-10.038v-1.61a7.002 7.002 0 0 1 0 13.258zM9.26 1.749a.75.75 0 0 1 1.5 0V18.25a.75.75 0 0 1-1.5 0zM3 10a7 7 0 0 1 4.75-6.629v1.61a5.5 5.5 0 0 0 0 10.038v1.61A7 7 0 0 1 3.001 10"
            />
        </svg>
    );
}
export default memo(IconFlipVerticalCircle20);
